document.addEventListener("DOMContentLoaded", () => {
  // Header: recherche en modale (comportement proche des thèmes Shopify)
  const searchDialog = document.querySelector("[data-search-dialog]");
  const searchOpen = document.querySelector("[data-search-open]");
  const searchCloseEls = document.querySelectorAll("[data-search-close]");
  const searchInput = document.querySelector("#header-search-q");

  if (searchDialog && searchOpen && typeof searchDialog.showModal === "function") {
    const searchForm = searchDialog.querySelector('form[role="search"]');

    searchOpen.addEventListener("click", () => {
      searchDialog.showModal();
      window.setTimeout(() => searchInput?.focus(), 0);
    });
    searchCloseEls.forEach((btn) => {
      btn.addEventListener("click", () => searchDialog.close());
    });
    searchDialog.addEventListener("click", (e) => {
      if (e.target === searchDialog) searchDialog.close();
    });

    document.querySelectorAll("[data-search-suggestion]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const q = btn.getAttribute("data-search-suggestion") || "";
        if (searchInput) searchInput.value = q;
        if (searchForm instanceof HTMLFormElement) searchForm.submit();
      });
    });
  }

  // Header : menu Compte (popup sous l’icône)
  const accountTrigger = document.querySelector("[data-account-menu-trigger]");
  const accountPanel = document.querySelector("[data-account-menu-panel]");
  if (accountTrigger && accountPanel) {
    const setAccountOpen = (open) => {
      accountPanel.hidden = !open;
      accountTrigger.setAttribute("aria-expanded", open ? "true" : "false");
    };

    accountTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      setAccountOpen(accountPanel.hidden);
    });

    document.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Node)) return;
      if (accountTrigger.contains(t) || accountPanel.contains(t)) return;
      if (!accountPanel.hidden) setAccountOpen(false);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !accountPanel.hidden) setAccountOpen(false);
    });
  }

  // Header behavior on scroll (transparent on home until threshold)
  const header = document.querySelector("[data-site-header]");
  const logo = document.querySelector("[data-site-header-logo]");
  if (header && logo) {
    const threshold = 80;
    const isHome =
      window.location.pathname === "/" || window.location.pathname === "";

    const setSolid = (solid) => {
      header.classList.toggle("bg-primary/95", solid);
      header.classList.toggle("backdrop-blur-md", solid);
      header.classList.toggle("shadow-sm", solid);
      header.classList.toggle("py-2", solid);

      header.classList.toggle("bg-transparent", !solid);
      header.classList.toggle("pt-6", !solid);
      header.classList.toggle("pb-4", !solid);

      // Hydrogen: logo md height changes with header state.
      logo.classList.toggle("md:h-16", solid);
      logo.classList.toggle("md:h-20", !solid);
    };

    const onScroll = () => {
      const isScrolled = window.scrollY > threshold;
      const solid = !isHome || isScrolled;
      setSolid(solid);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // DidYouKnow slider (auto + arrows + dots) — une instance par section
  document.querySelectorAll("[data-didyouknow]").forEach((did) => {
    const slides = Array.from(did.querySelectorAll("[data-did-slide]"));
    const dots = Array.from(did.querySelectorAll("[data-did-dot]"));
    const prevBtn = did.querySelector("[data-did-prev]");
    const nextBtn = did.querySelector("[data-did-next]");
    const pauseOnHover = did.getAttribute("data-did-pause-on-hover") !== "false";

    if (slides.length === 0) return;

    let current = 0;
    let paused = false;
    const intervalMs = Number(did.getAttribute("data-did-interval-ms") || 8000);

    const panel = did.querySelector("[data-did-panel]");
    const panelBgClasses = ["bg-amber-50", "bg-rose-50", "bg-pink-50"];
    const panelBorderClasses = ["border-amber-200", "border-rose-200", "border-pink-200"];

    const setCurrent = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((s, i) => {
        s.classList.toggle("hidden", i !== current);
      });
      const activeSlide = slides[current];
      const dotBgClass = activeSlide?.getAttribute("data-did-dot-bg") || "bg-primary";
      const accentBgClassesToRemove = ["bg-primary", "bg-amber-700", "bg-pink-600"];

      if (panel && activeSlide) {
        const bg = activeSlide.getAttribute("data-did-bg");
        const border = activeSlide.getAttribute("data-did-border");
        panelBgClasses.forEach((c) => panel.classList.remove(c));
        panelBorderClasses.forEach((c) => panel.classList.remove(c));
        if (bg) panel.classList.add(bg);
        if (border) panel.classList.add(border);
      }

      dots.forEach((d, i) => {
        const active = i === current;
        d.setAttribute("aria-current", active ? "true" : "false");
        d.classList.toggle("scale-125", active);
        accentBgClassesToRemove.forEach((c) => d.classList.remove(c));
        if (active) {
          d.classList.remove("bg-gray-300");
          d.classList.add(dotBgClass);
        } else {
          d.classList.add("bg-gray-300");
        }
      });
    };

    const next = () => setCurrent(current + 1);
    const prev = () => setCurrent(current - 1);

    if (pauseOnHover) {
      did.addEventListener("mouseenter", () => {
        paused = true;
      });
      did.addEventListener("mouseleave", () => {
        paused = false;
      });
    }

    const onPrev = (e) => {
      e.preventDefault();
      prev();
    };
    const onNext = (e) => {
      e.preventDefault();
      next();
    };

    prevBtn?.addEventListener("click", onPrev);
    nextBtn?.addEventListener("click", onNext);

    dots.forEach((dot, i) => {
      dot.addEventListener("click", (e) => {
        e.preventDefault();
        setCurrent(i);
      });
    });

    setCurrent(0);

    if (intervalMs > 0 && slides.length > 1) {
      window.setInterval(() => {
        if (paused) return;
        next();
      }, intervalMs);
    }
  });

  // Galerie « Nos jus en images » : défilement, boucle, autoplay (comme JuiceGalleryCarousel.tsx)
  const gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    const strip = gallery.querySelector("[data-gallery-strip]");
    const prevBtn = gallery.querySelector("[data-gallery-prev]");
    const nextBtn = gallery.querySelector("[data-gallery-next]");
    const lightbox = gallery.querySelector("[data-lightbox]");
    const lightboxImg = gallery.querySelector("[data-lightbox-img]");
    const lightboxClose = gallery.querySelector("[data-lightbox-close]");
    const autoplayMs = Number(gallery.getAttribute("data-gallery-autoplay-ms") || 0);
    const pauseOnHover = gallery.getAttribute("data-gallery-pause-on-hover") !== "false";

    const galleryItems = () => Array.from(gallery.querySelectorAll("[data-gallery-img]"));

    const scrollByAmount = () => {
      const first = strip?.querySelector("[data-gallery-img]");
      if (!first) return 600;
      const card = first.getBoundingClientRect();
      const gapRaw = strip ? window.getComputedStyle(strip).gap : "0px";
      const gap = Number.parseFloat(gapRaw || "0") || 0;
      return Math.max(280, Math.round(card.width + gap));
    };

    const maxScrollLeft = () => {
      if (!strip) return 0;
      return Math.max(0, strip.scrollWidth - strip.clientWidth);
    };

    /** Si scrollWidth ≈ clientWidth (bug flex/grid sans min-w-0), on défile quand même via scrollIntoView */
    const scrollGalleryIntoView = (direction) => {
      const items = galleryItems();
      if (!strip || items.length === 0) return;
      const sr = strip.getBoundingClientRect();
      const tol = 4;
      if (direction === "next") {
        for (let i = 0; i < items.length; i++) {
          const r = items[i].getBoundingClientRect();
          if (r.right > sr.right + tol) {
            items[i].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
            return;
          }
        }
        items[0].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      } else {
        for (let i = items.length - 1; i >= 0; i--) {
          const r = items[i].getBoundingClientRect();
          if (r.left < sr.left - tol) {
            items[i].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
            return;
          }
        }
        items[items.length - 1].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      }
    };

    const scrollNext = () => {
      if (!strip) return;
      const max = maxScrollLeft();
      if (max <= 2) {
        scrollGalleryIntoView("next");
        return;
      }
      if (strip.scrollLeft >= max - 2) {
        strip.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        strip.scrollBy({ left: scrollByAmount(), behavior: "smooth" });
      }
    };

    const scrollPrev = () => {
      if (!strip) return;
      const max = maxScrollLeft();
      if (max <= 2) {
        scrollGalleryIntoView("prev");
        return;
      }
      if (strip.scrollLeft <= 2) {
        strip.scrollTo({ left: max, behavior: "smooth" });
      } else {
        strip.scrollBy({ left: -scrollByAmount(), behavior: "smooth" });
      }
    };

    let autoplayId = null;
    const stopAutoplay = () => {
      if (autoplayId != null) {
        window.clearInterval(autoplayId);
        autoplayId = null;
      }
    };
    const startAutoplay = () => {
      if (autoplayMs <= 0) return;
      stopAutoplay();
      autoplayId = window.setInterval(scrollNext, autoplayMs);
    };

    const openLightbox = (src) => {
      if (!lightbox || !lightboxImg) return;
      stopAutoplay();
      lightboxImg.src = src;
      lightbox.classList.remove("hidden");
      lightbox.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.add("hidden");
      lightbox.setAttribute("aria-hidden", "true");
      if (lightboxImg) lightboxImg.src = "";
      document.body.style.overflow = "";
      startAutoplay();
    };

    gallery.querySelectorAll("[data-gallery-img]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const src = btn.getAttribute("data-src");
        if (src) openLightbox(src);
      });
    });

    prevBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      scrollPrev();
    });
    nextBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      scrollNext();
    });

    lightboxClose?.addEventListener("click", closeLightbox);
    lightbox?.addEventListener("click", (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (target.closest("[data-lightbox-close], [data-lightbox-img]")) return;
      closeLightbox();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && lightbox && !lightbox.classList.contains("hidden")) {
        closeLightbox();
      }
    });

    if (pauseOnHover && autoplayMs > 0) {
      gallery.addEventListener("mouseenter", stopAutoplay);
      gallery.addEventListener("mouseleave", startAutoplay);
    }

    startAutoplay();
  }

  // Témoignages : carrousel horizontal (2 cartes visibles en md+, flèches + boucle)
  const testi = document.querySelector("[data-testimonials]");
  if (testi) {
    const viewport = testi.querySelector("[data-testi-viewport]");
    const slides = Array.from(testi.querySelectorAll("[data-testi-slide]"));
    const prevBtn = testi.querySelector("[data-testi-prev]");
    const nextBtn = testi.querySelector("[data-testi-next]");

    const scrollByAmount = () => {
      const first = slides[0];
      if (!first || !viewport) return 320;
      const w = first.getBoundingClientRect().width;
      const gapRaw = window.getComputedStyle(viewport).gap || "0px";
      const gap = Number.parseFloat(gapRaw) || 0;
      return Math.round(w + gap);
    };

    const maxScroll = () =>
      viewport ? Math.max(0, viewport.scrollWidth - viewport.clientWidth) : 0;

    const scrollTestiIntoView = (direction) => {
      if (!viewport || slides.length === 0) return;
      const vr = viewport.getBoundingClientRect();
      const tol = 4;
      if (direction === "next") {
        for (let i = 0; i < slides.length; i++) {
          const r = slides[i].getBoundingClientRect();
          if (r.right > vr.right + tol) {
            slides[i].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
            return;
          }
        }
        slides[0].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      } else {
        for (let i = slides.length - 1; i >= 0; i--) {
          const r = slides[i].getBoundingClientRect();
          if (r.left < vr.left - tol) {
            slides[i].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
            return;
          }
        }
        slides[slides.length - 1].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
      }
    };

    const scrollNext = () => {
      if (!viewport) return;
      const max = maxScroll();
      if (max <= 4) {
        scrollTestiIntoView("next");
        return;
      }
      if (viewport.scrollLeft >= max - 4) {
        viewport.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        viewport.scrollBy({ left: scrollByAmount(), behavior: "smooth" });
      }
    };

    const scrollPrev = () => {
      if (!viewport) return;
      const max = maxScroll();
      if (max <= 4) {
        scrollTestiIntoView("prev");
        return;
      }
      if (viewport.scrollLeft <= 4) {
        viewport.scrollTo({ left: max, behavior: "smooth" });
      } else {
        viewport.scrollBy({ left: -scrollByAmount(), behavior: "smooth" });
      }
    };

    prevBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      scrollPrev();
    });
    nextBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      scrollNext();
    });

    if (viewport) {
      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;

      const onPointerDown = (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        isDown = true;
        startX = e.pageX;
        startScrollLeft = viewport.scrollLeft;
        viewport.setPointerCapture?.(e.pointerId);
      };

      const onPointerMove = (e) => {
        if (!isDown) return;
        viewport.scrollLeft = startScrollLeft - (e.pageX - startX);
      };

      const onPointerUp = () => {
        isDown = false;
      };

      viewport.addEventListener("pointerdown", onPointerDown);
      viewport.addEventListener("pointermove", onPointerMove);
      viewport.addEventListener("pointerup", onPointerUp);
      viewport.addEventListener("pointercancel", onPointerUp);
      viewport.addEventListener("pointerleave", onPointerUp);
    }
  }

  // ProductDetail (taille + quantité) — bloc « L'Énergisant » sur la home
  const pd = document.querySelector("[data-product-detail]");
  if (pd) {
    const priceEl = pd.querySelector("[data-pd-price]");
    const variantInput = pd.querySelector("[data-pd-variant-id-input]");
    const qtyHidden = pd.querySelector("[data-pd-qty-hidden]");
    const qtyInput = pd.querySelector("[data-pd-qty-input]");
    const minusBtn = pd.querySelector("[data-pd-qty-minus]");
    const plusBtn = pd.querySelector("[data-pd-qty-plus]");
    const cartForm = pd.querySelector("[data-pd-cart-form]");
    const sizeButtons = Array.from(pd.querySelectorAll("[data-pd-size-btn]"));

    let qty = parseInt(qtyInput?.value || "1", 10);
    if (!Number.isFinite(qty)) qty = 1;

    const clampQty = (n) => Math.min(99, Math.max(1, n));

    const setQty = (n) => {
      qty = clampQty(n);
      if (qtyInput) qtyInput.value = String(qty);
      if (qtyHidden) qtyHidden.value = String(qty);
    };

    const getCurrentQty = () => {
      const raw = qtyInput?.value?.trim() ?? "";
      if (raw === "") return qty;
      const n = parseInt(raw, 10);
      if (Number.isNaN(n)) return qty;
      return clampQty(n);
    };

    const applySelectedSize = (btn) => {
      const isSelected = (b) => b === btn;

      sizeButtons.forEach((b) => {
        const selected = isSelected(b);

        b.style.backgroundColor = selected ? "hsl(var(--foreground))" : "hsl(var(--background))";
        b.style.color = selected ? "hsl(var(--background))" : "hsl(var(--foreground))";
        b.style.borderColor = selected ? "hsl(var(--foreground))" : "hsl(var(--border))";

        b.classList.toggle("border-foreground", selected);
        b.classList.toggle("bg-foreground", selected);
        b.classList.toggle("text-background", selected);

        b.classList.toggle("border-border", !selected);
        b.classList.toggle("hover:border-foreground", !selected);
        b.classList.toggle("text-foreground", !selected);
      });

      const variantId = btn.getAttribute("data-pd-variant-id");
      const priceDisplay = btn.getAttribute("data-pd-price-display");

      if (variantInput && variantId) variantInput.value = variantId;
      if (priceEl && priceDisplay) priceEl.textContent = priceDisplay;
    };

    sizeButtons.forEach((btn) => {
      btn.addEventListener("click", () => applySelectedSize(btn));
    });

    minusBtn?.addEventListener("click", () => setQty(getCurrentQty() - 1));
    plusBtn?.addEventListener("click", () => setQty(getCurrentQty() + 1));

    const syncQtyFromInput = () => {
      if (!qtyInput) return;
      const raw = qtyInput.value.trim();
      if (raw === "") {
        setQty(qty);
        return;
      }
      const n = parseInt(raw, 10);
      if (Number.isNaN(n)) {
        setQty(qty);
        return;
      }
      setQty(n);
    };

    qtyInput?.addEventListener("input", syncQtyFromInput);
    qtyInput?.addEventListener("blur", syncQtyFromInput);
    qtyInput?.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        qtyInput.blur();
      }
    });

    cartForm?.addEventListener("submit", () => {
      syncQtyFromInput();
    });

    const initialId = variantInput?.value;
    const initialBtn = sizeButtons.find((b) => b.getAttribute("data-pd-variant-id") === initialId);
    if (initialBtn) applySelectedSize(initialBtn);
    else if (sizeButtons.length > 0) applySelectedSize(sizeButtons[0]);

    setQty(qty);
  }

  // ShopPreview (home) : variations de taille + prix dynamique par carte
  const homeVariantButtons = Array.from(
    document.querySelectorAll("[data-home-variant-btn]"),
  );
  if (homeVariantButtons.length > 0) {
    const updateHomeCardVariant = (cardId, variantId, priceText, variantTitle) => {
      if (!cardId || !variantId) return;

      const cardButtons = document.querySelectorAll(
        `[data-home-variant-btn][data-home-card-id="${cardId}"]`,
      );
      cardButtons.forEach((btn) => {
        const isActive = btn.getAttribute("data-home-variant-id") === variantId;
        btn.classList.toggle("bg-foreground", isActive);
        btn.classList.toggle("text-white", isActive);
        btn.classList.toggle("bg-muted", !isActive);
        btn.classList.toggle("text-muted-foreground", !isActive);
      });

      const priceNode = document.querySelector(
        `[data-home-price][data-home-card-id="${cardId}"]`,
      );
      if (priceNode && priceText) priceNode.textContent = priceText;

      const hiddenInput = document.querySelector(
        `[data-home-variant-id-input][data-home-card-id="${cardId}"]`,
      );
      if (hiddenInput) hiddenInput.value = variantId;

      const labelNode = document.querySelector(
        `[data-home-variant-label][data-home-card-id="${cardId}"]`,
      );
      if (labelNode) {
        labelNode.textContent = variantTitle
          ? `/ ${variantTitle}`
          : "";
      }
    };

    homeVariantButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const cardId = btn.getAttribute("data-home-card-id");
        const variantId = btn.getAttribute("data-home-variant-id");
        const variantPrice = btn.getAttribute("data-home-variant-price");
        const variantTitle = (btn.textContent || "").trim();
        updateHomeCardVariant(cardId, variantId, variantPrice, variantTitle);
      });
    });
  }

  // ShopPreview (home) : carte produit cliquable vers la fiche
  document.querySelectorAll("[data-home-product-card]").forEach((card) => {
    card.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      // Ne pas interférer avec favoris, variantes, formulaire, bouton panier, liens.
      if (target.closest("button, a, form, input, select, textarea, label")) return;

      const url = card.getAttribute("data-home-product-url");
      if (url) window.location.href = url;
    });
  });

  // Favoris (localStorage) : toggle sur les coeurs + rendu page Favoris
  const FAVORITES_KEY = "lesjusdemamie_favorites";

  const readFavorites = () => {
    try {
      const raw = window.localStorage.getItem(FAVORITES_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item) => item && typeof item.handle === "string");
    } catch {
      return [];
    }
  };

  const writeFavorites = (items) => {
    try {
      window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(items));
    } catch {
      // no-op
    }
  };

  const isFavorite = (handle) => readFavorites().some((item) => item.handle === handle);

  const setFavoriteButtonState = (button, active) => {
    const icon = button.querySelector("svg");
    button.setAttribute("aria-pressed", active ? "true" : "false");
    button.classList.toggle("bg-primary", active);
    button.classList.toggle("border-primary", active);
    button.classList.toggle("bg-white/80", !active);
    if (icon) {
      icon.setAttribute("fill", active ? "currentColor" : "none");
      icon.classList.toggle("text-primary-foreground", active);
      icon.classList.toggle("text-primary", !active);
    }
  };

  const favoriteButtons = document.querySelectorAll("[data-favorite-toggle]");
  favoriteButtons.forEach((button) => {
    const handle = button.getAttribute("data-favorite-handle");
    if (!handle) return;

    setFavoriteButtonState(button, isFavorite(handle));

    button.addEventListener("click", () => {
      const title = button.getAttribute("data-favorite-title") || "";
      const url = button.getAttribute("data-favorite-url") || "";
      const image = button.getAttribute("data-favorite-image") || "";
      const price = button.getAttribute("data-favorite-price") || "";
      const current = readFavorites();
      const existingIndex = current.findIndex((item) => item.handle === handle);

      if (existingIndex >= 0) {
        current.splice(existingIndex, 1);
        writeFavorites(current);
        setFavoriteButtonState(button, false);
      } else {
        current.unshift({ handle, title, url, image, price });
        writeFavorites(current.slice(0, 100));
        setFavoriteButtonState(button, true);
      }
    });
  });

  const favoritesList = document.querySelector("#favorites-list");
  const favoritesEmpty = document.querySelector("#favorites-empty");
  const isFavoritesSearchMode =
    window.location.pathname === "/search" &&
    new URLSearchParams(window.location.search).get("favoris") === "1";

  if (isFavoritesSearchMode) {
    // Mise à jour du titre/description uniquement dans la page search (jamais dans la modale header).
    const pageRoot = document.querySelector("[data-search-page-root]");
    if (pageRoot) {
      const bannerSection = pageRoot.previousElementSibling;
      const titleEl = bannerSection?.querySelector("h1");
      const descEl = bannerSection?.querySelector("p");
      if (titleEl) titleEl.textContent = "Mes favoris";
      if (descEl) descEl.textContent = "Retrouvez ici les produits que vous avez enregistrés.";
    }
  }

  if (isFavoritesSearchMode && (!favoritesList || !favoritesEmpty)) {
    const pageRoot = document.querySelector("[data-search-page-root]");
    if (!pageRoot) return;

    // On ne touche qu'à la page de recherche/favoris, jamais à la modale du header.
    pageRoot.innerHTML = `
      <div class="mx-auto" style="max-width: 980px;">
        <div class="flex items-center justify-between gap-4 mb-6">
          <a href="/collections/all" class="inline-flex items-center gap-2 font-outfit text-sm text-muted-foreground hover:text-foreground transition-colors">
            <span aria-hidden="true">←</span>
            Continuer mes achats
          </a>
        </div>
        <div id="favorites-list" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 justify-items-center"></div>
        <div id="favorites-empty" class="rounded-2xl border border-border/60 bg-card p-8 sm:p-10 text-center mx-auto" style="max-width: 720px; width: 100%;">
          <p class="font-outfit text-muted-foreground mb-4">Vous n’avez pas encore de favoris.</p>
          <a href="/collections/all" class="inline-flex items-center justify-center h-11 px-6 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-outfit transition-colors">
            Découvrir la boutique
          </a>
        </div>
      </div>
      <script id="favorites-products-data" type="application/json">[]</script>
    `;
  }

  const resolvedFavoritesList = document.querySelector("#favorites-list");
  const resolvedFavoritesEmpty = document.querySelector("#favorites-empty");
  if (resolvedFavoritesList && resolvedFavoritesEmpty) {
    const favorites = readFavorites();

    const escapeHtml = (value) => {
      const div = document.createElement("div");
      div.textContent = String(value ?? "");
      return div.innerHTML;
    };

    const normalizeFavoriteUrl = (value, handle) => {
      const fallback = `/products/${encodeURIComponent(handle || "")}`;
      if (!value || typeof value !== "string") return fallback;
      const trimmed = value.trim();
      if (trimmed.startsWith("/")) return trimmed;
      if (trimmed.startsWith("https://")) return trimmed;
      return fallback;
    };

    const normalizeImageUrl = (value) => {
      if (!value || typeof value !== "string") return "";
      const trimmed = value.trim();
      if (trimmed.startsWith("https://")) return trimmed;
      if (trimmed.startsWith("//")) return `https:${trimmed}`;
      if (trimmed.startsWith("/")) return trimmed;
      return "";
    };

    const renderFavorites = (items) => {
      if (!items.length) {
        resolvedFavoritesList.innerHTML = "";
        resolvedFavoritesEmpty.classList.remove("hidden");
        return;
      }

      resolvedFavoritesEmpty.classList.add("hidden");
      resolvedFavoritesList.innerHTML = items
        .map((item) => {
          const safeTitle = escapeHtml(item.title || item.handle || "");
          const safeUrl = escapeHtml(normalizeFavoriteUrl(item.url, item.handle));
          const safeImage = escapeHtml(normalizeImageUrl(item.image));
          const safePrice = escapeHtml(item.price || "");
          return `
            <a href="${safeUrl}" class="block w-full max-w-[300px] rounded-2xl overflow-hidden border border-border/60 bg-card hover:shadow-soft transition-shadow">
              <div class="aspect-square bg-[hsl(var(--cream))]">${safeImage ? `<img src="${safeImage}" alt="${safeTitle}" class="w-full h-full object-cover" loading="lazy" />` : ""}</div>
              <div class="p-4">
                <p class="font-outfit font-semibold text-foreground line-clamp-1">${safeTitle}</p>
                ${safePrice ? `<p class="font-outfit text-primary font-medium mt-1">${safePrice}</p>` : ""}
              </div>
            </a>
          `;
        })
        .join("");
    };

    renderFavorites(favorites);
  }
});

